<template>
  <div class="toggle-selector">
    <div @click="selectNone" class="toggle-selector__item">
      Select None
    </div>
    <div @click="selectAll" class="toggle-selector__item">
      Select All
    </div>
  </div>
</template>

<script>
  export default {
    name: 'multiselect-toggle-all-selector',
    methods: {
      selectAll() {
        this.$emit('select-all');
      },

      selectNone() {
        this.$emit('select-none');
      },
    },
  }
</script>

<style scoped lang="scss">
  //.toggle-selector {
  //  margin: 0;
  //  padding: 0;
  //
  //  display: flex;
  //  justify-content: space-around;
  //  align-items: center;
  //  white-space: nowrap;
  //  cursor: pointer;
  //  font-weight: 500;
  //  background-color: #155a7a;
  //  border-top: 1px solid #11445a;
  //
  //  &__item {
  //    margin: 0;
  //    padding: 8px 0;
  //    width: 100%;
  //    text-align: center;
  //  }
  //
  //  &__item:first-child {
  //    border-right: 1px solid #11445a;
  //  }
  //
  //  &__item:hover {
  //    background-color: #1f91bd;
  //  }
  //}
</style>
